import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "gl_cookie_consent";

/**
 * Cookie consent banner.
 * We only set strictly-necessary cookies right now (no analytics/ads),
 * so this is essentially an acknowledgement banner — GDPR-compliant because
 * we're not doing any consent-required tracking yet. If we ever add
 * analytics, we'll extend this to gate that opt-in.
 */
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Delay to avoid layout thrash on first paint
    const id = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 800);
    return () => clearTimeout(id);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ v: 1, accepted_at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      data-testid="cookie-banner"
      className="fixed left-1/2 -translate-x-1/2 bottom-4 z-[130] w-[calc(100%-1.5rem)] max-w-2xl bg-[#241C18] text-[#F9F8F5] rounded-2xl shadow-2xl px-5 py-4 md:px-6 md:py-5 flex flex-col md:flex-row md:items-center gap-4"
    >
      <p className="text-sm leading-relaxed flex-1">
        We only use cookies that are strictly necessary to make the shop work (login, cart, language).{" "}
        <Link to="/legal/cookies" className="underline hover:text-[var(--gl-orange)]">Read our cookie policy</Link>.
      </p>
      <button
        data-testid="cookie-accept-btn"
        onClick={accept}
        className="whitespace-nowrap rounded-full px-5 py-2.5 bg-[var(--gl-orange)] text-[var(--gl-orange-text)] font-badge text-[11px] tracking-[0.24em] uppercase hover:bg-[var(--gl-orange-hover)] hover:text-white transition"
      >
        Got it
      </button>
    </div>
  );
};

export default CookieBanner;
